import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonDeploymentTargetOverview, CommonDeploymentTargetTopics } from "../../CommonComponents/CommonDeploymentTargetViews";

export const InfrastructureDeploymentTargetsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.infrastructure.machines.root,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonDeploymentTargetOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonDeploymentTargetTopics />;
    },
};
